import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-[#F8F3EC]" data-id="element-82" data-mp="3djueifd6yagl">
      <div className="max-w-5xl mx-auto" data-id="element-83" data-mp="3dkm9pp2vm66c">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#520128] text-center mb-12 uppercase" data-id="element-84" data-mp="3ij70yz05hfin">
          Everything Included in <span className="text-[#8E2C5C]" data-id="element-85" data-mp="3mlttz38k56hf">Sewing &amp; Pattern Making Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-86" data-mp="xs6karpkaw1h">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-[#520128] border-b-4 border-[#C9A24A] rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-87" data-mp="11sqilylvg5p7">
              <Icon size={28} className="text-[#E3C27A]" aria-hidden="true" data-id="element-88" data-mp="1dc14kj2dj6i5" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-89" data-mp="18av9wfp5l95z">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-90" data-mp="zbgjthcwf0m0">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-[#E6D5BF] rounded-xl p-4 flex items-center gap-3" data-id="element-91" data-mp="uinh0z0zq2ck">
              <span className="w-9 h-9 rounded-lg bg-[#520128] text-[#E3C27A] flex items-center justify-center shrink-0" data-id="element-92" data-mp="kmkevt6523pm">
                <Icon size={18} aria-hidden="true" data-id="element-93" data-mp="gjfepx9j6e45" />
              </span>
              <span className="text-[#520128] font-bold text-xs uppercase leading-tight" data-id="element-94" data-mp="blm5evcxl3zn">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-[#520128] rounded-3xl p-8 md:p-12 shadow-xl shadow-[#520128]/10 text-center" data-id="element-95" data-mp="1w6xoftjjek9">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-96" data-mp="ko9kk8wrzr2y" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#520128] mb-1" data-id="element-97" data-mp="ppf9rwr88w7q">
            SEWING &amp; PATTERN MAKING INSTRUCTOR <span className="text-[#8E2C5C]" data-id="element-98" data-mp="fwzsl1nr8bnw">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-[#8A6A2B] mb-3" data-id="element-99" data-mp="fv6mpokytvgy">
            The Complete 6-IN-1 Visual Sewing, Pattern Making &amp; Garment Construction System for Sewing Instructors, Pattern-Making Teachers &amp; Sewing Academies
          </p>
          <p className="text-base text-slate-700/80 max-w-2xl mx-auto mb-8" data-id="element-100" data-mp="2t37mbwvkezhx">
            A complete visual training system created to help sewing instructors plan, explain, demonstrate
            and assess every core sewing and pattern-making skill with more clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-[#520128] mb-1" data-id="element-101" data-mp="2xw9184vruz1i">YOUR PRICE:</p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#8E2C5C] mb-6" data-id="element-102" data-mp="2a66c9xn5m974">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-103" data-mp="258mzz3a0o6ht">
            {PRIMARY_CTA}
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-104" data-mp="3ul8c7rnqqexe">
            Immediate Access · 6 Visual Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-[#E6D5BF]" data-id="element-105" data-mp="3plc69mvhgdf7">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-[#520128] mb-2 uppercase" data-id="element-106" data-mp="or61j33dsvb4">
              Stop Planning Every Sewing Class From Scratch.
            </p>
            <p className="text-lg font-semibold text-[#8A6A2B]" data-id="element-107" data-mp="tru32ip8kujl">OPEN IT. CHOOSE IT. SHOW IT. TEACH IT.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}